var render = function (_h,_vm) {var _c=_vm._c;return _c('font-awesome-icon',{staticClass:"fa-icons",attrs:{"icon":['far', 'comment']}})}
var staticRenderFns = []

export { render, staticRenderFns }